<script>
// NOTICE: KAPTION-INTEGRATION
import { mapGetters } from 'vuex';
import NextButton from 'dashboard/components-next/button/Button.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import SettingsLayout from '../SettingsLayout.vue';
import PolicyCard from './PolicyCard.vue';

export default {
  components: {
    SettingsLayout,
    NextButton,
    BaseSettingsHeader,
    PolicyCard,
  },
  computed: {
    ...mapGetters({
      policies: 'kaptionResponsePolicies/getPolicies',
      uiFlags: 'kaptionResponsePolicies/getUIFlags',
    }),
  },
  mounted() {
    this.$store.dispatch('kaptionResponsePolicies/get');
  },
  methods: {
    navigateToCreate() {
      this.$router.push({
        name: 'settings_kaption_response_policies_new',
      });
    },
    navigateToReports() {
      this.$router.push({
        name: 'settings_kaption_response_policies_reports',
      });
    },
    editPolicy(policy) {
      this.$router.push({
        name: 'settings_kaption_response_policies_edit',
        params: { policyId: policy.id },
      });
    },
  },
};
</script>

<template>
  <SettingsLayout
    :is-loading="uiFlags.fetchingList"
    :loading-message="$t('KAPTION_RESPONSE_POLICIES.LOADING')"
    :no-records-message="$t('KAPTION_RESPONSE_POLICIES.LIST.404')"
    :no-records-found="!policies.length"
  >
    <template #header>
      <BaseSettingsHeader
        :title="$t('KAPTION_RESPONSE_POLICIES.HEADER')"
        :description="$t('KAPTION_RESPONSE_POLICIES.DESCRIPTION')"
      >
        <template #actions>
          <NextButton
            blue
            icon="i-lucide-circle-plus"
            :label="$t('KAPTION_RESPONSE_POLICIES.HEADER_BTN_TXT')"
            @click="navigateToCreate"
          />
        </template>
      </BaseSettingsHeader>
    </template>
    <template #body>
      <!-- Tabs -->
      <div class="mb-6 flex gap-1 border-b border-n-weak">
        <button
          class="px-4 py-2 text-sm font-medium transition-colors border-b-2 border-b-solid text-b-solid"
        >
          {{ $t('KAPTION_RESPONSE_POLICIES.REPORTS.TAB_POLICIES') }}
        </button>
        <button
          class="px-4 py-2 text-sm font-medium transition-colors border-b-2 border-transparent text-n-slate-11 hover:text-n-slate-12"
          @click="navigateToReports"
        >
          {{ $t('KAPTION_RESPONSE_POLICIES.REPORTS.TAB_REPORTS') }}
        </button>
      </div>

      <div class="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        <PolicyCard
          v-for="policy in policies"
          :key="policy.id"
          :policy="policy"
          @edit="editPolicy"
        />
      </div>
    </template>
  </SettingsLayout>
</template>
